<template>
    <transition name="fade" mode="out-in">
        <div
            v-if="isOpen"
            data-testid="recommendedPopup"
            class="recommended-popup-container"
            cy-data="popup"
        >
            <div class="recommended-popup">
                <button
                    type="button"
                    class="close-btn"
                    aria-label="Close popup"
                    @click="$emit('close')"
                >
                    <img src="@/assets/close_icon.svg" alt="close icon" />
                </button>
                <div class="icon-wrapper">
                    <img src="@/assets/recommended-popup-icon.svg" alt="icon" />
                </div>
                <p class="recommended-popup-title">
                    {{ $t(`${TRANSLATION_KEY}.mobileAccuracyHeader`) }}
                </p>
                <p class="recommended-popup-p">
                    {{ $t(`${TRANSLATION_KEY}.mobileAccuracyDescription`) }}
                </p>
                <p class="recommended-popup-p">
                    {{ $t(`${TRANSLATION_KEY}.limitationsAcknowledgement`) }}
                </p>

                <div class="recommended-popup-buttons">
                    <button
                        data-testid="btn-recommendedPopup-next"
                        class="understand-btn"
                        @click="handleBackToMobileUpload"
                    >
                        {{ $t(`${TRANSLATION_KEY}.proceedButton`) }}
                    </button>
                    <button
                        data-testid="btn-recommendedPopup-back"
                        type="button"
                        class="action-btn"
                        @click="$emit('close')"
                    >
                        <img src="@/assets/arrow.svg" alt="arrow icon" />
                        <span>{{
                            $t(`${TRANSLATION_KEY}.backToMobileUploadButton`)
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { Action } from '@/constants/ajax';
import { Locale } from '@/constants/locale';
import {
    AmplitudeAnalyticsEvents,
    amplitudeSendEvent,
} from '@/utils/AmplitudeAnalyticsEvents';

export default defineComponent({
    name: 'RecomendedPopup',
    props: {
        isOpen: Boolean,
    },
    emits: ['close'],
    setup(_, { emit }) {
        const store = useStore();
        const { t } = useI18n();
        const TRANSLATION_KEY = 'steps.RecommendedPopup';

        const handleBackToMobileUpload = (): void => {
            emit('close');
            store.dispatch('ajax', {
                data: {
                    dataUploadChoice: 2,
                },
                action: Action.DATA_UPLOAD_CHOICE,
            });
            amplitudeSendEvent(
                AmplitudeAnalyticsEvents.proofOfIdentity
                    .PROOF_OF_IDENTITY_POPUP_CONTINUE
            );
        };

        return {
            emit,
            t,
            TRANSLATION_KEY,
            Locale,
            handleBackToMobileUpload,
        };
    },
});
</script>

<style lang="scss">
.recommended-popup-container {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;

    .recommended-popup {
        position: relative;
        background-color: #fff;
        padding: 30px;
        max-width: 420px;
        border-radius: 6px;

        .icon-wrapper {
            text-align: center;
        }

        .recommended-popup-title {
            font-size: 15px;
            font-weight: 700;
            text-align: center;
        }
        .recommended-popup-p {
            font-size: 13px;
            text-align: center;
        }

        .close-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 30px;
            height: 30px;
            padding: 0;
            border-radius: 50%;
            background-color: #fff;
            border: 3px solid rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.7);
            cursor: pointer;
            z-index: 3;

            &:focus-visible {
                outline: 2px solid #192241;
                outline-offset: 2px;
            }
        }

        .recommended-popup-buttons {
            display: flex;
            flex-direction: column;
            gap: 20px;
            .understand-btn {
                margin-top: 20px;
                width: 100%;
                border: 1px solid #00214a;
                outline: none;
                padding: 20px;
                background-color: transparent;
                font-size: 18px;
                font-weight: 700;
                text-transform: uppercase;
                cursor: pointer;

                &:focus-visible {
                    outline: 2px solid #192241;
                    outline-offset: 2px;
                }
            }
            .action-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;
                border: none;
                background: transparent;
                padding: 0;
                cursor: pointer;

                &:focus-visible {
                    outline: 2px solid #192241;
                    outline-offset: 2px;
                    border-radius: 4px;
                }

                span {
                    font-weight: 600;
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
